import { render, staticRenderFns } from "./ProductStockIframe.vue?vue&type=template&id=1dc3602a&"
import script from "./ProductStockIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductStockIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports